import request from '@/utils/request'

export function addUserVoting(data) {
  return request({
    url: '/addUserVoting',
    method: 'post',
    data
  })
}

export function loggedIn(data) {
  return request({
    url: '/updateIsLoggedIn',
    method: 'post',
    data
  })
}

export function addNewVoting(data) {
  return request({
    url: '/admin/addNewVoting',
    method: 'post',
    data
  })
}

export function importVotingUsers(data) {
  return request({
    url: '/admin/importVotingUsers',
    method: 'post',
    data
  })
}

export function importVotingCandidates(data) {
  return request({
    url: '/admin/importVotingCandidates',
    method: 'post',
    data
  })
}

export function getEventVoting(data) {
  return request({
    url: '/admin/getEventVoting/' + data,
    method: 'get',
  })
}

export function updateNewVoting(data) {
  return request({
    url: '/admin/updateNewVoting',
    method: 'post',
    data

  })
}

export function getVoteInfo(data) {
  return request({
    url: '/admin/getVoteInfo',
    method: 'post',
    data
  })
}

export function getRateResult(data) {
  return request({
    url: '/admin/getRateResult',
    method: 'post',
    data
  })
}

export function getPresentsStatus(data) {
  return request({
    url: '/admin/getPresentsStatus',
    method: 'post',
    data
  })
}
